export default __webpack_public_path__ + "static/media/1.74df76a6.png";